/*
 * userQualificationLUClass.dto.ts
 */
// import {
//   mtUserQualificationLUCategoryDto,
//   moUserQualificationLUCategoryInit,
// } from 'src/user/dto/userQualificationLUCategory.dto';
//
export type mtUserQualificationLUClassDto = {
  cpinID: number;
  cpidCreatedAt: Date;
  cpidUpdatedAt: Date;
  cpidDeletedAt: Date | null;
  //
  cpinIDUserQualificationLUCategory: number;
  cpisClass: string;
  cpisUX: string;
  cpisRemarks: string | null;
  //
  // cpioUserQualificationLUCateogry: mtUserQualificationLUCategoryDto;
};
//
export type mtUserQualificationLUClassCreateDto = Omit<
  mtUserQualificationLUClassDto,
  'cpinID' | 'cpidCreatedAt' | 'cpidUpdatedAt' | 'cpidDeletedAt'
>;
//
export type mtUserQualificationLUClassUpdateDto = Omit<
  mtUserQualificationLUClassDto,
  'cpidCreatedAt' | 'cpidUpdatedAt' | 'cpidDeletedAt'
>;
//
export const moUserQualificationLUClassInit: mtUserQualificationLUClassDto = {
  cpinID: Date.now() * -1,
  cpidCreatedAt: new Date(),
  cpidUpdatedAt: new Date(),
  cpidDeletedAt: null,
  cpinIDUserQualificationLUCategory: 0,
  cpisClass: 'eUNDEFINED',
  cpisUX: 'UNDEFINED',
  cpisRemarks: null,
  // cpioUserQualificationLUCateogry: { ...moUserQualificationLUCategoryInit },
};
//#end#
